import clsx from 'clsx'
import React, {useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {MenuComponent} from '../../../assets/ts/components'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {TopBar} from './TopBar'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'

export function HeaderWrapper() {
  const {pathname} = useLocation()
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config

  const {
    images: {logo, favicon},
  } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

  const imgPath = logo ? logo : toAbsoluteUrl('/media/logos/Logo-WF_1.png')

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [pathname])

  return (
      <div
          id='kt_header'
          className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
          {...attributes.headerMenu}
      >
        <div
            className={clsx(
                classes.headerContainer.join(' '),
                'd-flex align-items-stretch justify-content-between'
            )}
        >
          {/* begin::Aside mobile toggle */}
          {aside.display && (
              <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
                <div
                    className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
                    id='kt_aside_mobile_toggle'
                >
                  <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
                </div>
              </div>
          )}
          {/* end::Aside mobile toggle */}
          {/* begin::Logo */}
          {!aside.display && (
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to="/dashboard" className="d-lg-none ">
                  <img alt="Logo" className="h-45px" src={imgPath} style={{objectFit: 'cover'}} />

                  <img alt="Logo" src={imgPath} className="h-45px" />
                </Link>
              </div>
          )}
          {/* end::Logo */}

          {aside.display && (
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/' className='d-lg-none'>
                  <img alt='Logo' src={imgPath} className='h-20px w-100' style={{objectFit: 'contain'}} />
                </Link>
              </div>
          )}

          {/* begin::Wrapper */}
          <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
            {/* begin::Navbar */}
            {header.left === 'menu' && (
                <div className='d-flex align-items-stretch' id='kt_header_nav'>
                  {/*<Header />*/}
                  {/*<h1 className='text-success p-3 m-3 bg-light-success'>こんにちは世界! 🌎</h1>*/}
                </div>
            )}

            {header.left === 'page-title' && (
                <div className='d-flex align-items-center' id='kt_header_nav'>
                  {/*<DefaultTitle />*/}
                </div>
            )}

            <div className='d-flex align-items-stretch flex-shrink-0'>
              <TopBar />
            </div>
          </div>
          {/* end::Wrapper */}
        </div>
      </div>
  )
}
